import { z } from 'zod';
export const ARCHIVE_ENTITY_TYPES = [
    'patient',
    'order',
    'result',
    'provider',
    'lab_client',
    'panel',
    'test_type',
    'reference_range',
    'payer',
    'reference_lab',
    'device',
    'user',
];
export const archiveEntityTypeSchema = z.enum(ARCHIVE_ENTITY_TYPES);
export const legalHoldBodySchema = z.object({ enabled: z.boolean() }).strict();
export const archiveListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    search: z.string().max(200).optional(),
});
export const archiveStatsEntrySchema = z.object({
    entityType: archiveEntityTypeSchema,
    total: z.number().int().min(0),
    legalHold: z.number().int().min(0),
    purgeableAfter: z.string().nullable(),
});
export const archiveStatsResponseSchema = z.object({
    stats: z.array(archiveStatsEntrySchema),
});
//# sourceMappingURL=archive.js.map